import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { leagueIds, sportIds } from 'src/constants/personalizationIds'
import { useIsFuboSportsAvailable } from 'src/modules/hooks/useIsFuboSportsAvailable'
import { getFuboSportsCBBPlans } from 'src/constants/planData/fuboSportsCBBPlans'

export default (props) => {
  const { isAvailable } = useIsFuboSportsAvailable()

  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/NCAA_BTN_LP_15s.mp4'}
      title="Watch Big Ten Network with Fubo"
      subtitle="Enjoy college hoops all season"
      networkSet="basketball"
      customNetworks={['bigten']}
      league="nba"
      showRSN={true}
      sportId={sportIds.Basketball}
      leagueId={leagueIds["Men's NCAA Basketball"]}
      hasPlanCards={isAvailable}
      plans={isAvailable ? getFuboSportsCBBPlans() : []}
    />
  )
}
